
<van-dialog
  v-model="visible"
  :title="$t('c329ccef3a')"
  class="switchAccountDialog"
  :close-on-click-overlay="false"
  :show-confirm-button="false"
  @closed="handleClose"
>
  <div class="switch-content">
    「{{ companyName }}」{{ $t('e370f9afb1')
    }}<img class="switch-content-logo" :src="userLogo" />
    <span class="switch-content-name">{{ userName }}</span
    >{{ $t('410cf42585') }}
  </div>
  <div class="switch-footer">
    <div class="switch-footer-btn" type="primary" @click="handleClick">
      {{ $t('062d48aece') }}
    </div>
    <div class="switch-footer-time">{{ times }}s{{ $t('95a105d412') }}</div>
  </div>
</van-dialog>
